export const bookingTotalPriceSelector = (state) => {
    if (!!state.reducer.selectedVehicle) {
        return  + parseFloat(state.reducer.selectedVehicle.tarif).toFixed(2) +
            ((state.reducer.addedKm) *
                +state.reducer.selectedVehicle.prixKm) + (state.reducer.priceOption1 * state.reducer.selectedVehicle.totalDays) + state.reducer.priceOption2 + state.reducer.priceOption3
    }

    return null
}
